import { GridValueFormatterParams } from '@mui/x-data-grid-pro';
import { format, parseISO } from 'date-fns';

import { Formatters } from './formatters';
import { User } from '../model/user';

export class DataGridFormatters {
    public static numberLocaleFormatterFn(options?: Intl.NumberFormatOptions) {
        return (params: GridValueFormatterParams): string => {
            return Math.round(Number(params.value)).toLocaleString(undefined, options);
        };
    }

    public static numberLocaleFormatter(params: GridValueFormatterParams): string {
        return Math.round(Number(params.value)).toLocaleString();
    }

    public static currencyLocaleFormatter(params: GridValueFormatterParams): string {
        return Number(params.value).toLocaleString(undefined, { maximumFractionDigits: 2, minimumFractionDigits: 2 });
    }

    public static usernameFormatter(params: GridValueFormatterParams): string {
        return Formatters.userDisplayName(params.value as User);
    }

    public static dateFormatter(params: GridValueFormatterParams): string {
        if (!params.value) {
            return '';
        }

        return format(parseISO(params.value as string), 'MM/dd/yyyy');
    }

    public static dateTimeFormatter(params: GridValueFormatterParams): string {
        return Formatters.dateTime(params.value as string);
    }

    public static monthYearFormatter(params: GridValueFormatterParams): string {
        return Formatters.monthYearFormatter(params.value as string);
    }

    public static seamRequestId(params: GridValueFormatterParams): string {
        return Formatters.seamRequestId(params.value as string);
    }
}
